import React from 'react'
import { useFormikContext } from 'formik'
import { rationalNumbers } from 'Core/masks'

import { TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

export const DiscountPrice = () => {
	const formik = useFormikContext()

	const error = formik.touched.discountedPrice && formik.errors.discountedPrice

	return (
		<Wrapper isError={error}>
			<TextInputNew
				id='discountedPrice'
				name='discountedPrice'
				title='Cijena sa popustom'
				value={formik.values.discountedPrice}
				mask={rationalNumbers}
				allowedCharacters={['rational']}
				measure='€'
				onChange={async textValue => {
					const priceValue = Number(formik.values.price)

					await formik.setFieldValue('discountedPrice', Number(textValue) < priceValue ? textValue : -1)

					if (!formik.touched.discountedPrice) formik.setFieldTouched('discountedPrice', true)
				}}
			/>
		</Wrapper>
	)
}
